import { Extension } from '@tiptap/react';

export const DisableEnterExtension = Extension.create({
  addKeyboardShortcuts() {
    return {
      Enter: () => true,
    };
  },
});
